export default {
    phone: '511 999 00',
    desc: 'hvis du ringer fra utsiden av Rogaland',
    orgnization_number: 'Org. nr.: 914 749 360'
}